import * as z from "zod";

export const paymentMethodStatusValue = z.enum([
  "active",
  "missing",
  "error",
  "requires_verification",
]);

export type PaymentMethodStatus = z.infer<typeof paymentMethodStatusValue>;
